import { FieldErrorTypes } from 'modules/ui/errorMessages/ErrorMessagesDirective';
import './BotMigrationModal.scss';
import { ORGANIZATION_MIGRATION_MODAL_CONFIRM_BUTTON, ORGANIZATION_MIGRATION_MODAL_CLOSE, ORGANIZATION_MIGRATION_RULES, ORGANIZATION_MIGRATION_KEEP_MOVING, ORGANIZATION_MIGRATION_OPEN_CONTRACT, } from 'modules/application/tenant/TenantSegmentEvents';
import { ListApplicationFeatures } from '../../application/list/ListApplicationFeatures';
export class BotMigrationModalController {
    static $inject = ['applicationsShortNames', 'TenantService', '$translate', 'close', 'selectedTenant', 'SegmentService', 'BlipToastService', 'isMovingChatbot', 'estimatedDate', 'tenantIdOrigin'];
    constructor(applicationsShortNames, TenantService, $translate, close, selectedTenant, SegmentService, BlipToastService, isMovingChatbot, estimatedDate, tenantIdOrigin) {
        'ngInject';
        this.applicationsShortNames = applicationsShortNames;
        this.TenantService = TenantService;
        this.$translate = $translate;
        this.close = close;
        this.selectedTenant = selectedTenant;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.isMovingChatbot = isMovingChatbot;
        this.estimatedDate = estimatedDate;
        this.tenantIdOrigin = tenantIdOrigin;
        this.tenantFieldName = 'tenantField';
    }
    $onInit() {
        this.isLoading = false;
        this.buttonDisabled = true;
        this.pages = {
            confirm: true,
            success: false,
        };
        this.tenantFieldErrorMessages = {
            [FieldErrorTypes.pattern]: this.$translate.instant('migrationWarning.errors.name').replace('{tenantName}', this.selectedTenant.name),
        };
    }
    async assignBot() {
        const promises = [];
        this.pages.confirm = false;
        this.isLoading = true;
        try {
            if (!this.isMovingChatbot) {
                promises.push(this.TenantService.assignMultipleBotsToTenant(this.applicationsShortNames, this.selectedTenant.id, this.isMovingChatbot));
                await Promise.all(promises);
                this.isToShowSucess = true;
            }
            else {
                promises.push(this.TenantService.addToQueueMigrationBots(this.applicationsShortNames, this.tenantIdOrigin, this.selectedTenant.id));
                await Promise.all(promises);
                this.groupIdMigration = this.TenantService.groupIdMigration;
                this.isToShowSucess = false;
            }
            this.pages.success = true;
            this.isLoading = false;
            this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_MODAL_CONFIRM_BUTTON);
            if (await ListApplicationFeatures.contractAdminCanMigrateBots()) {
                this.isMovingChatbot = true;
                this.closeBotMigrationModal(true);
            }
        }
        catch (e) {
            console.error(e);
            let errorMessage, errorTitle;
            if (e.message?.includes('The follow command processing has timed out') || e.code === 61) {
                errorMessage = await this.$translate('migrationWarning.errors.timeout');
            }
            else {
                errorTitle = await this.$translate('applicationsMigration.errorWhileMovingTitle');
                errorMessage = await this.$translate('applicationsMigration.errorWhileMovingMsg');
            }
            if (errorMessage) {
                this.BlipToastService.show('danger', {
                    title: errorTitle,
                    msg: errorMessage,
                });
            }
            this.close();
        }
    }
    onInputChange() {
        const isTenantNameValid = this.selectedTenant.name === this.typedTenantName;
        this.buttonDisabled = !isTenantNameValid;
        this.migrateTenantForm[this.tenantFieldName].$invalid = !isTenantNameValid;
        this.migrateTenantForm[this.tenantFieldName].$valid = isTenantNameValid;
        this.migrateTenantForm[this.tenantFieldName].$setValidity(FieldErrorTypes.pattern, isTenantNameValid);
    }
    goToTenant() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_OPEN_CONTRACT);
        window.location.href = this.TenantService.getTenantUrl(this.selectedTenant.id, true);
    }
    closeBotMigrationModal(reload = false) {
        if (this.pages.success) {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_KEEP_MOVING);
        }
        else {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_MODAL_CLOSE);
        }
        this.close(reload);
    }
    onMigratonRulesClick() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MIGRATION_RULES);
        window.open('https://help.blip.ai', '_blank');
    }
}
BotMigrationModalController.$inject = ['applicationsShortNames', 'TenantService', '$translate', 'close', 'selectedTenant', 'SegmentService', 'BlipToastService', 'isMovingChatbot', 'estimatedDate', 'tenantIdOrigin'];
